<template>
  <div>
    <base-dialog
      @save-item="saveItem"
      dialogId="edit-card-dialog"
      :open.sync="openDialog"
      :form-ref.sync="cardFormRef"
      maxWidth="1200px"
      :loading.sync="isLoading"
    >
      <template v-slot:[`dialog.title`]>
        <span>Editer une carte</span>
      </template>
      <template v-slot:[`dialog.content`]>
        <v-row>
          <v-col cols="8">
            <v-text-field
              v-model="cardForm.password"
              label="Mot de passe"
              hint="Mot de passe associé à la carte pour la connexion au portail client"
              persistent-hint
              :rules="rules.passwordRules"
            ></v-text-field>

            <v-autocomplete
              no-filter
              v-model="cardForm.client"
              item-value="id"
              item-text="description"
              :items="portals"
              :loading="loadingPortals"
              :search-input.sync="portalSearch"
              label="Client"
              :no-data-text="
                portalSearch
                  ? 'Aucun portail ne correspond à la recherche'
                  : 'Veuillez renseigner un nom de portail'
              "
              :rules="rules.clientRules"
            ></v-autocomplete>

            <v-select
              v-model="cardForm.cardOrigin"
              label="Origine de la carte"
              :items="cardOriginsChoice"
              persistent-hint
            ></v-select>

            <v-select
              v-model="cardForm.cardType"
              label="Type de la carte"
              :items="cardTypesChoice"
              persistent-hint
              hint="Type de cartes:
- DECOMPTE: Le temps est consommé sans logout,
- TEMPS: Durée de connexion fixée,
- SEMINAR: Spécifique pour certaines chambres/salles pendant une période de temps fixée.
- BILLING: La carte sera facturée plus tard"
            ></v-select>

            <v-select
              v-model="cardForm.restrictionType"
              label="Type de restriction"
              :items="restrictionTypesChoice"
              hint="Peut être utilisé dans un autre contexte que le client"
              persistent-hint
              :rules="rules.restrictionType"
            ></v-select>
            <v-select
              v-model="cardForm.mode"
              label="Mode"
              :items="modesChoice"
              item-value="value"
              item-text="text"
              hint="Le mode détermine le profile de connexion"
              persistent-hint
              :rules="rules.modeRules"
            ></v-select>

            <v-text-field
              v-model.number="cardForm.simultaneousSessionsNum"
              label="Nombre de sessions simultanées autorisées (optional)"
              hint="Il s'agit du nombre de sessions simultanées authorisées pour une carte. Cela peut être vu comme le nombre de périphérique (PC, Smartphone, tablettes) authorisé à ce se connecter en même temps avec la même carte.
laisser vide ce champs siginifie : pas de limite"
              persistent-hint
              type="number"
            >
            </v-text-field>

            <v-text-field
              v-model.number="cardForm.maxConnectionDuration"
              label="Durée max de connexion (optional)"
              hint="Une carte DECOMPTE à une 'durée maximale de connexion' (son temps d'utilisation).
        Une carte TEMPS doit avoir une 'durée maximale de connexion' VIDE !
        "
              type="number"
              persistent-hint
            >
            </v-text-field>

            <v-text-field
              v-model.number="cardForm.maxUsageDuration"
              label="Durée maximale d'utilisation (optional)"
              hint="Si une carte DECOMPTE à une 'durée maximale d'utilisation', la carte sera valable le temps de cette valeure à partir de la première utilisation sinon le champs doit être VIDE !
        Une carte TEMPS à une 'durée maximale d'utilisation' Cette durée définie la date de fin de la carte à partir de la 1ère utilisation.
        "
              type="number"
              persistent-hint
            >
            </v-text-field>

            <v-text-field
              v-model.number="cardForm.idleTimeout"
              label="IDLE Timeout"
              hint="IDLE Timeout"
              persistent-hint
              type="number"
            >
            </v-text-field>

            <v-text-field
              v-model="cardForm.firstUseMac"
              label="First Use MAC"
              hint="First Use MAC"
              persistent-hint
            >
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <v-alert type="error">
              Les durées sont exprimées en secondes
            </v-alert>
            <v-simple-table v-if="cardOriginal.profile != null" dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td class="font-weight-bold">Nom :</td>
                    <td>{{ cardOriginal.profile.lastname }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Prénom :</td>
                    <td>{{ cardOriginal.profile.firstname }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Email :</td>
                    <td>{{ cardOriginal.profile.email }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Téléphone :</td>
                    <td>
                      {{ cardOriginal.profile.phone }}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Inscrit le :</td>
                    <td>
                      {{
                        getInternationalDate(
                          cardOriginal.profile.registeredAt.date
                        )
                      }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <table
              style="text-align: left; width: 330px; height: 128px"
              border="0"
              cellpadding="2"
              cellspacing="2"
            >
              <tbody>
                <tr>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(204, 204, 204);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    600
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(204, 204, 204);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    10 Minutes
                  </td>

                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(136, 136, 136);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    86400
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(136, 136, 136);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    1 jour
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(204, 204, 204);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    900
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(204, 204, 204);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    15 Minutes
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(136, 136, 136);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    259200
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(136, 136, 136);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    3 jours
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(204, 204, 204);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    1800
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(204, 204, 204);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    30 Minutes
                  </td>

                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(136, 136, 136);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    345600
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(136, 136, 136);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    4 jours
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(160, 160, 160);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    3600
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(160, 160, 160);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    1 heure
                  </td>

                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(136, 136, 136);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    432000
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(136, 136, 136);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    5 jours
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    <br />
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    <br />
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(160, 160, 160);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    7200
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(160, 160, 160);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    2 heures
                  </td>

                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(136, 136, 136);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    604800
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(136, 136, 136);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    7 jours
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    <br />
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    <br />
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(160, 160, 160);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    10800
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(160, 160, 160);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    3 heures
                  </td>

                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(136, 136, 136);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    691200
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(136, 136, 136);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    8 jours
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    <br />
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    <br />
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(160, 160, 160);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    21600
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(160, 160, 160);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    6 heures
                  </td>

                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(102, 102, 102);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    2678400
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(102, 102, 102);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    1 mois
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    <br />
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    <br />
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(160, 160, 160);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    28800
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(160, 160, 160);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    8 heures
                  </td>

                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(102, 102, 102);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    8035200
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(102, 102, 102);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    3 mois
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    <br />
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    <br />
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(160, 160, 160);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    36000
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(160, 160, 160);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    10 heures
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(102, 102, 102);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    16070400
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(102, 102, 102);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    6 mois<br />
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(160, 160, 160);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    43200
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(160, 160, 160);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    12 heures
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(160, 160, 160);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    86400
                  </td>
                  <td
                    style="
                      vertical-align: top;
                      background-color: rgb(160, 160, 160);
                      font-family: Helvetica, Arial, sans-serif;
                    "
                  >
                    24 heures
                  </td>
                </tr>
              </tbody>
            </table>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`dialog.actions.save`]>Créer</template>
    </base-dialog>
  </div>
</template>
<script>
import { toRefs, computed, onMounted, ref, watch } from "@vue/composition-api";
import { useCard } from "@/composables/card";
import BaseDialog from "@/components/General/BaseDialog.vue";
import { useClientPortal } from "../../composables/client-portal";
import { date } from "../../composables/date";
import { useCardModel } from "../../composables/card-model";

export default {
  components: {
    BaseDialog,
  },
  props: {
    cardOriginal: Object,
    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { cardData, updateCard } = useCard();
    const { cardModelData } = useCardModel();

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    const {
      mode,
      password,
      cardOrigin,
      cardType,
      restrictionType,
      simultaneousSessionsNum,
      maxUsageDuration,
      maxConnectionDuration,
      idleTimeout,
      firstUseMac,
      client,
    } = props.cardOriginal;

    /* Cycle de vie */
    onMounted(() => {
      cardData.cardForm = {
        mode: mode.id,
        password,
        cardOrigin: cardOrigin.id,
        cardType: cardType.id,
        restrictionType: restrictionType.id,
        simultaneousSessionsNum,
        maxUsageDuration,
        maxConnectionDuration,
        idleTimeout,
        firstUseMac,
        client: client.id,
      };
    });

    /* Méthodes */
    const saveItem = async function () {
      await updateCard(props.cardOriginal.id);
      openDialog.value = cardData.editCardDialog;
    };

    const { listClientPortals, data } = useClientPortal();

    /* Variables */
    const loadingPortals = ref(false);
    const portalSearch = ref("");
    const portalTimerId = ref(0);
    const debounceInterval = 500;
    const fetchingPortal = ref(false);

    // init autocomplete
    data.clientPortals.data = [props.cardOriginal.client];
    const portals = computed(function () {
      return data.clientPortals.data;
    });

    /* Méthodes */
    const fetchPortals = async function () {
      loadingPortals.value = true;
      await listClientPortals(null, portalSearch.value);
      loadingPortals.value = false;
    };

    /* Watchers */
    watch(
      () => portalSearch.value,
      (newValue, oldValue) => {
        if (newValue != oldValue && newValue) {
          clearTimeout(portalTimerId.value);
          portalTimerId.value = setTimeout(() => {
            fetchPortals();
          }, debounceInterval);
        }
      }
    );

    const { getInternationalDate } = date();

    return {
      updateCard,
      ...toRefs(cardData),
      saveItem,
      openDialog,
      loadingPortals,
      portals,
      portalSearch,
      fetchingPortal,
      getInternationalDate,
      ...toRefs(cardModelData),
    };
  },
};
</script>
